/**
 * A one-line spoken summary of a case-list row for Cammy — built only from
 * fields the Cases list already rendered for that row (status, plate/ref,
 * country, received time, warnings), never an extra fetch. Hovering or
 * clicking a row has to stay instant, and the list only ever has the summary
 * data it already fetched for itself.
 */

const hasWarning = (warning) =>
  !!warning?.message && warning.message !== "No warnings";

/** Same shape getRowWarnings (CasesRedesign.js) filters down to — kept in
 * sync by hand since that one lives beside JSX this module can't import. */
export const realWarningsOf = (caseItem) => {
  const warnings = caseItem?.warnings;
  if (!Array.isArray(warnings)) {
    return warnings && warnings !== "No warnings" ? [{ message: warnings }] : [];
  }
  return warnings.filter(hasWarning);
};

export const summarizeCaseForCammy = (caseItem) => {
  if (!caseItem) return "";

  const id = caseItem.caseId || caseItem.fullCaseId || caseItem.refNum;
  const lead = id ? `Case ${id}` : "This case";
  const status = caseItem.status ? `is ${caseItem.status}` : null;

  const facts = [];
  if (caseItem.country && caseItem.country !== "Unknown") {
    facts.push(caseItem.country);
  }
  if (caseItem.timestamp && caseItem.timestamp !== "N/A") {
    facts.push(`received ${caseItem.timestamp}`);
  }

  let sentence = [lead, status].filter(Boolean).join(" ");
  if (facts.length) sentence += ` — ${facts.join(", ")}`;

  const warnings = realWarningsOf(caseItem);
  if (warnings.length === 1) {
    sentence += `. Flagged: ${warnings[0].message}`;
  } else if (warnings.length > 1) {
    sentence += `. ${warnings.length} warnings flagged`;
  }

  return `${sentence}.`;
};

export default summarizeCaseForCammy;
